import React from 'react';

import { CloseOutline } from 'ui/components/Icon';

import confirm, { destroyFns } from './ModalConfirm/confirm';

import { IModalFuncProps } from './types';

import { StyledModal as Modal } from './styled';

Modal.defaultProps = {
  cancelText: 'Отмена',
  closeIcon: <CloseOutline />,
};

Modal.confirm = function confirmFn(props: IModalFuncProps) {
  return confirm(props);
};

Modal.error = function errorFn(props: IModalFuncProps) {
  return confirm({ ...props, modalType: 'error' });
};

Modal.success = function successFn(props: IModalFuncProps) {
  return confirm({ ...props, modalType: 'success' });
};

Modal.info = function infoFn(props: IModalFuncProps) {
  return confirm({ ...props, modalType: 'info' });
};

Modal.destroyAll = function destroyAllFn() {
  while (destroyFns.length) {
    const close = destroyFns.pop();
    if (close) {
      close();
    }
  }
};
// as unknown as TModalType
export { Modal };
